import { EditorFilesMobileFooter } from "./EditorFilesMobileFooter/EditorFilesMobileFooter";
import { EditorFooter } from "./EditorFooter/EditorFooter";
import { Footer } from "./Footer/Footer";

export const MultiPostFromFiles = {
  EditorFilesMobileFooter,
  EditorFooter,
  Footer,
};
